import { Paper } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import PesquisarLivroAta from "./PesquisarLivroAta/PesquisarLivroAta"
import AtasTable from "../AtasTable/AtasTable"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import { useContext, useEffect, useState } from "react"

const ListarLivroAta = ({ setIdEdit, filtros, setFiltros }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)

    const [observacoes, setObservacoes] = useState([])
    const [ocorrencias, setOcorrencias] = useState([])

    addRoute("buscarTodasObs", (msg) => {
        if (msg.error) {
            console.log(msg.error)
            return
        }
        let observacoes = []
        let ocorrencias = []
        msg.data.obs.map((obs) => {
            if (obs.tipo == 1) {
                observacoes.push(obs)
            } else {
                ocorrencias.push(obs)
            }
        })
        setObservacoes(observacoes)
        setOcorrencias(ocorrencias)
        setFiltros(msg.data.filtros)
    })
    useEffect(() => {
        sendWs("buscarTodasObs", { filtros })
    }, [])

    return (
        <Paper sx={{
            backgroundColor: '#D9D9D9',
            width: '100%',
            padding: '3px 10px',
            // display: 'flex',
            flexDirection: 'column',
            alignContent: 'start',
            // justifyContent: 'space-between',
            // height: { lg: '100%', xl: '100%' },
            height: '100%'
            // flexGrow: 1,
        }}>
            <Grid item xs={12} sx={{ height: '15%' }}>
                <PesquisarLivroAta filtros={filtros} setFiltros={setFiltros} />
            </Grid>
            <Grid item container xs={12} sx={{ height: '83%', width: '100%' }}>
                <Grid item container xs={12} sx={{ maxHeight: { lg: '44%', xl: '46%' } }}>
                    <AtasTable tipo="observacao" dados={observacoes} setIdEdit={setIdEdit} filtros={filtros} />
                </Grid>
                <Grid item container xs={12} sx={{ maxHeight: { lg: '44%', xl: '46%' } }}>
                    <AtasTable tipo="ocorrencia" dados={ocorrencias} setIdEdit={setIdEdit} filtros={filtros} />
                </Grid>
            </Grid>
        </Paper>
    )
}

export default ListarLivroAta
